module.exports = __webpack_public_path__ + "img/analyzing-photo-mobile-ru.62ccb121.jpg";